module.exports = __webpack_public_path__ + "static/media/work.dee861aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/work.svg
// module id = 110
// module chunks = 0